import { Formik, Form, ErrorMessage, Field } from 'formik';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import Modal from '@mui/material/Modal';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getLabelsByInstituteType } from '../../utils/constants';
import {
  postStudentData,
  studentIdCheck,
  uploadImage,
} from '../../features/student/studentSlice';
import { getClasses } from '../../features/classes/ClassSlice';
import ReactDatePicker from '../UIElements/ReactDatePicker';
const AddStudent = ({ setAddStudent, refreshStudents }) => {
  const [successModal, setSuccessModal] = useState(false);
  const [viewPhoto, setViewPhoto] = useState(null);
  const [idError, setIdError] = useState(false);
  const [classDetails, setClassDetails] = useState([]);
  const [currentDepartment, setCurrentDepartment] = useState({});
  const [currentClasses, setCurrentClass] = useState([]);

  const [currentSections, setCurrentSections] = useState([]);

  const dispatch = useDispatch();
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  async function getclasses() {
    const list = await dispatch(getClasses()).unwrap();
    setClassDetails(list !== 'error' ? list : []);
  }

  function convertNumberToWords(number) {
    const ones = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];

    if (number === 0) return 'zero';
    if (number > 10000000)
      return '⚠️ Number too large. Maximum allowed is 8 digits.';
    function numToWords(n, suffix) {
      let str = '';
      if (n > 19) {
        str += tens[Math.floor(n / 10)] + (n % 10 ? '-' + ones[n % 10] : '');
      } else if (n > 0) {
        str += ones[n];
      }
      if (n !== 0) str += ' ' + suffix + ' ';
      return str;
    }

    let output = '';
    output += numToWords(Math.floor(number / 10000000), 'crore');
    output += numToWords(Math.floor((number / 100000) % 100), 'lakh');
    output += numToWords(Math.floor((number / 1000) % 100), 'thousand');
    output += numToWords(Math.floor((number / 100) % 10), 'hundred');

    if (number > 100 && number % 100 !== 0) {
      output += 'and ';
    }

    output += numToWords(number % 100, '');

    return output.trim().charAt(0).toUpperCase() + output.slice(1) + ' Rupees';
  }
  useEffect(() => {
    getclasses();
  }, []);
  return (
    <>
      <div className='w-full'>
        <Formik
          initialValues={{
            studentId: '',
            studentRollNumber: '',
            firstName: '',
            lastName: '',
            dateOfBirth: null,
            mobileNumber: '',
            gender: '',
            guardian: {
              name: '',
              relation: '',
              contactNumber: '',
            },
            communicationAddress: '',
            studentPhoto: '',
            departmentName: '',
            className: '',
            sectionName: '',
            totalFees: '',
            dateOfJoining: '',
            dateOfLeaving: null,
            remarks: '',
          }}
          validationSchema={Yup.object({
            studentId: Yup.string()
              .required('Enter Id')
              .matches(/^[A-Za-z0-9]+$/, 'Only alphanumeric characters'),
            studentRollNumber: Yup.number()
              .required('Enter Roll No')
              .min(1, 'Starts from 1'),
            firstName: Yup.string()
              .transform((value) =>
                typeof value === 'string' ? value.trim() : '',
              )

              .required('Enter First Name ')
              .matches(
                /^[A-Za-z\s]+$/,
                'First name must contain only alphabets',
              )
              .min(2, 'First name must be at least 2 characters')
              .max(50, 'First name must be less than 50 characters'),

            lastName: Yup.string()
              .required('Enter Last Name ')
              .matches(/^[A-Za-z\s]+$/, 'Last name must contain only alphabets')
              .min(2, 'Last name must be at least 2 characters')
              .max(50, 'Last name must be less than 50 characters'),
            dateOfBirth: Yup.date()
              .nullable()
              .max(new Date(), 'Date of birth cannot be in the future')
              .required('Enter Date Of Birth'),
            mobileNumber: Yup.string()
              .matches(
                /^[6-9]\d{9}$/,
                'Enter a valid 10-digit Indian mobile number',
              )
              .required('Guardian  Number is required'),
            gender: Yup.string().required('Select Gender'),
            //studentPhoto: Yup.mixed().required(' upload photo'),
            guardian: Yup.object().shape({
              name: Yup.string()
                .required('Guardian Name is required')
                .matches(/^[A-Za-z\s]+$/, ' name must contain only alphabets')
                .min(2, ' name must be at least 2 characters')
                .max(50, ' name must be less than 50 characters'),
              relation: Yup.string().required('Guardian Relation is required'),
              contactNumber: Yup.string()
                .matches(
                  /^[6-9]\d{9}$/,
                  'Enter a valid 10-digit Indian mobile number',
                )
                .required('Guardian  Number is required'),
            }),
            communicationAddress: Yup.string()
              .transform((value) => (value ? value.trim() : ''))
              .required('Enter Address'),
            departmentName: Yup.string().required('Select Department'),
            className: Yup.string().required(`select ${Class}`),
            // sectionName: Yup.string().required(`select ${Section}`
            // ),
            totalFees: Yup.number()
              .required('Enter Fee')
              .min(1, ' Fee must be Positive')
              .max(10000000, 'must be below 1 Crore'),
            dateOfJoining: Yup.date().required('Enter Date Of Joining'),
            dateOfLeaving: Yup.date()
              .nullable()
              .min(
                Yup.ref('dateOfJoining'),
                'Date of leaving cannot be before the date of joining',
              ),
            remarks: Yup.string().max(
              100,
              'Maximun 100 characters only allowed',
            ),
          })}
          onSubmit={async (values, actions) => {
            values = Object.fromEntries(
              Object.entries(values).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.trim() : value,
              ]),
            );
            if (!idError) {
              const bool = await dispatch(postStudentData(values)).unwrap();
              if (bool) {
                refreshStudents();
                setSuccessModal(true);
                setTimeout(() => {
                  actions.resetForm();
                  setAddStudent(false);
                }, 3000);
              } else {
                alert('something went wrong,Try Again Later !');
              }
            }
          }}
        >
          {({
            setFieldError,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
          }) => (
            <>
              <div className='flex flex-col mx-auto '>
                <Form>
                  {/* Student Details */}
                  <div className='flex flex-col gap-3 md:flex-row'>
                    <div className='flex flex-col md:w-2/3'>
                      <div className='flex flex-col md:flex-row gap-x-3'>
                        <div className='mb-3 md:w-1/2'>
                          <label htmlFor='studentId' className='text-sm '>
                            Student ID
                            <span className='text-lg text-red-800 '>*</span>
                          </label>
                          <Field name='studentId'>
                            {({ field }) => (
                              <input
                                {...field}
                                type='text'
                                placeholder='STU0000'
                                className=' formik-input'
                                onBlur={async (e) => {
                                  field.onBlur(e);
                                  const value = e.target.value;
                                  if (value) {
                                    const isDuplicate = await dispatch(
                                      studentIdCheck(value),
                                    ).unwrap();
                                    isDuplicate
                                      ? setIdError(true)
                                      : setIdError(false);
                                  } else {
                                    setIdError(false);
                                  }
                                }}
                                onMouseLeave={async (e) => {
                                  const value = e.target.value;
                                  if (value) {
                                    const isDuplicate = await dispatch(
                                      studentIdCheck(value),
                                    ).unwrap();
                                    isDuplicate
                                      ? setIdError(true)
                                      : setIdError(false);
                                  } else setIdError(false);
                                }}
                              />
                            )}
                          </Field>
                          <div className='text-red-500'>
                            {idError ? 'Student Id Already exsits' : ''}
                          </div>
                          <ErrorMessage
                            name='studentId'
                            component='div'
                            className='mt-1 text-sm text-red-600'
                          />
                        </div>
                        <div className='mb-3 md:w-1/2'>
                          <label
                            htmlFor='studentRollNumber'
                            className='text-sm '
                          >
                            Student Roll No
                            <span className='text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='number'
                            id='studentRollNumber'
                            name='studentRollNumber'
                            placeholder=''
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='studentRollNumber'
                            component='div'
                            className='mt-1 text-sm text-red-600'
                          />
                        </div>
                      </div>

                      <div className='flex flex-col md:flex-row gap-x-3'>
                        <div className='mb-3 md:w-1/2'>
                          <label htmlFor='firstName' className='text-sm '>
                            First Name
                            <span className='text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='text'
                            id='firstName'
                            name='firstName'
                            placeholder='Enter Last Name'
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='firstName'
                            component='div'
                            className='mt-1 text-sm text-red-600'
                          />
                        </div>
                        <div className='mb-3 md:w-1/2'>
                          <label htmlFor='lastName' className='text-sm '>
                            Last Name
                            <span className='text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            type='text'
                            id='lastName'
                            name='lastName'
                            placeholder='Enter Last Name'
                            className='formik-input '
                          />
                          <ErrorMessage
                            name='lastName'
                            component='div'
                            className='mt-1 text-sm text-red-600'
                          />
                        </div>
                      </div>

                      <div className='flex flex-col md:flex-row gap-x-3'>
                        <div className='mb-3 md:w-1/2'>
                          <label htmlFor='dateOfBirth' className='text-sm '>
                            Date Of Birth
                            <span className='text-lg text-red-800 '>*</span>
                          </label>

                          <Field
                            name='dateOfBirth'
                            className='mt-1 formik-input'
                            component={ReactDatePicker}
                          />
                          <ErrorMessage
                            name='dateOfBirth'
                            component='div'
                            className='mt-1 text-sm text-red-600'
                          />
                        </div>
                        <div className='mb-3 md:w-1/2 '>
                          <label htmlFor='gender' className='text-sm '>
                            Gender{' '}
                            <span className='text-lg text-red-800 '>*</span>
                          </label>
                          <Field
                            as='select'
                            id='gender'
                            name='gender'
                            className='w-full formik-input '
                          >
                            <option value=''>Select</option>
                            <option value='Male'>Male</option>
                            <option value='Female'>Female</option>
                            <option value='Others'>Others</option>
                          </Field>
                          <ErrorMessage
                            name='gender'
                            component='div'
                            className='text-sm text-red-600 '
                          />
                        </div>
                      </div>
                    </div>
                    {/* Upload Photo */}
                    <div className='flex flex-col md:w-1/3 '>
                      <label className='m-1 text-sm '>Upload Photo </label>
                      <div className=' flex-1 rounded border-[1.5px] border-indigo-100 flex items-center justify-center mt-1 mb-3'>
                        <div className='flex items-center justify-center '>
                          <>
                            <Field name='studentPhoto'>
                              {() => (
                                <>
                                  <input
                                    type='file'
                                    id='studentPhoto'
                                    accept='image/*'
                                    onChange={async (event) => {
                                      const file =
                                        event.currentTarget.files?.[0];
                                      setFieldTouched(
                                        'studentPhoto',
                                        true,
                                        false,
                                      );

                                      if (file) {
                                        const allowedTypes = [
                                          'image/jpeg',
                                          'image/png',
                                          'image/jpg',
                                        ];
                                        const maxSize = 1 * 1024 * 1024;
                                        if (!allowedTypes.includes(file.type)) {
                                          setFieldError(
                                            'studentPhoto',
                                            'Only JPG and PNG files are allowed',
                                          );
                                          return;
                                        }
                                        if (file.size > maxSize) {
                                          setFieldError(
                                            'studentPhoto',
                                            'File too large (max 1MB)',
                                          );
                                          return;
                                        }
                                        const bool = await dispatch(
                                          uploadImage(file),
                                        ).unwrap();
                                        if (bool) {
                                          setFieldValue('studentPhoto', bool);
                                          setViewPhoto(file);
                                        }
                                      } else {
                                        setFieldValue('studentPhoto', null);
                                      }
                                    }}
                                    className='hidden '
                                  />

                                  {viewPhoto ? (
                                    <>
                                      <div className='flex items-center overflow-hidden justify-evenly size-full '>
                                        <div className='flex items-center w-3/5 h-52 '>
                                          <img
                                            src={URL.createObjectURL(viewPhoto)}
                                            alt='Upload Photo'
                                            className=' min-h-[70%]  max-h-[80%] object-contain rounded-md  aspect-square '
                                          />
                                        </div>
                                        <label htmlFor='studentPhoto'>
                                          <div className='flex flex-col'>
                                            <p className='p-1 font-semibold text-white bg-blue-400 rounded-md hover:bg-blue-600'>
                                              Modify
                                            </p>
                                          </div>
                                        </label>
                                      </div>
                                    </>
                                  ) : (
                                    <label htmlFor='studentPhoto'>
                                      <div className='flex flex-row items-center justify-center '>
                                        <img
                                          src='images/upload.jpg'
                                          alt=''
                                          className='w-1/2 '
                                        />

                                        <p className=''>
                                          <span className='text-blue-500 cursor-pointer'>
                                            Click to upload{' '}
                                          </span>
                                          or <br></br> Drag & Drop Here
                                        </p>
                                      </div>
                                    </label>
                                  )}
                                </>
                              )}
                            </Field>
                          </>
                        </div>
                      </div>
                      <div className='text-transparent'>
                        {errors.dateOfBirth || errors.gender}
                      </div>
                      <ErrorMessage
                        name='studentPhoto'
                        component='div'
                        className='text-sm text-red-600 '
                      />
                    </div>
                  </div>
                  {/* Communication Address */}
                  <div className='grid items-start grid-cols-1 gap-3 md:grid-cols-3'>
                    <div>
                      <label htmlFor='mobileNumber' className='text-sm '>
                        Mobile Number
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='mobileNumber'
                        name='mobileNumber'
                        placeholder='XXX-XXX-XXXX'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='mobileNumber'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                    <div className='col-span-2'>
                      <label
                        htmlFor='communicationAddress'
                        className='text-sm '
                      >
                        Communication Address
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='communicationAddress'
                        name='communicationAddress'
                        placeholder='Enter Communicaiton Address'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='communicationAddress'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                  </div>
                  {/* Guardian Details */}
                  <div className='grid grid-cols-1 gap-3 md:grid-cols-3 '>
                    <div className='w-full '>
                      <label htmlFor='guardian.relation' className='text-sm '>
                        Guardian Relation{' '}
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        as='select'
                        id='guardian.relation'
                        name='guardian.relation'
                        className='w-full formik-input '
                      >
                        <option value=''>Select</option>
                        <option value='Father'>Father</option>
                        <option value='Mother'>Mother</option>
                        <option value='Others'>Others</option>
                      </Field>
                      <ErrorMessage
                        name='guardian.relation'
                        component='div'
                        className='text-sm text-red-600 '
                      />
                    </div>
                    <div className='w-full '>
                      <label htmlFor='guardian.name' className='text-sm '>
                        Guardian Name
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='guardian.name'
                        name='guardian.name'
                        placeholder='Enter Guardian Name'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='guardian.name'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                    <div className='w-full '>
                      <label
                        htmlFor='guardian.contactNumber'
                        className='text-sm '
                      >
                        Guardian Number
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        id='guardian.contactNumber'
                        name='guardian.contactNumber'
                        placeholder='XXX-XXX-XXXX'
                        className='formik-input'
                      />
                      <ErrorMessage
                        name='guardian.contactNumber'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                  </div>

                  {/* class,fee,branch */}
                  <div className='grid items-start grid-cols-1 gap-3 md:grid-cols-3'>
                    {/* Department */}
                    <div className='w-full '>
                      <label htmlFor='departmentName' className='text-sm'>
                        {Department}{' '}
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field name='departmentName'>
                        {({ field }) => (
                          <select
                            {...field}
                            className='formik-input'
                            onChange={(e) => {
                              field.onChange(e);
                              const value = e.target.value;
                              setFieldValue('departmentName', value);
                              setFieldValue('className', '');
                              setFieldValue('sectionName', '');
                              const selectedDepartment = classDetails?.find(
                                (obj) => obj.department === value,
                              );
                              setCurrentDepartment(selectedDepartment);
                              setCurrentClass(selectedDepartment?.classes);
                              setCurrentSections([]);
                            }}
                          >
                            {classDetails?.length > 0 ? (
                              <option value=''>
                                ---Select {Department}---
                              </option>
                            ) : (
                              <option value=''>
                                --- No {Department} Available ---
                              </option>
                            )}
                            {classDetails?.map((item, index) => (
                              <option key={index} value={item.department}>
                                {item.department}
                              </option>
                            ))}
                          </select>
                        )}
                      </Field>
                      <ErrorMessage
                        name='departmentName'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                    {/* class */}
                    <div className='w-full '>
                      <label htmlFor='className' className='text-sm'>
                        {Class} <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field name='className'>
                        {({ field }) => (
                          <select
                            {...field}
                            className='formik-input'
                            onChange={(e) => {
                              field.onChange(e);
                              const value = e.target.value;
                              setFieldValue('className', value);
                              const selectedClass =
                                currentDepartment?.classes?.find(
                                  (obj) => obj.className === value,
                                );
                              setCurrentSections(selectedClass?.sections);
                            }}
                          >
                            {!values?.departmentName ? (
                              <option value=''>
                                ---First Select {Department} ---
                              </option>
                            ) : currentClasses?.length > 0 ? (
                              <option value=''>---Select {Class}----</option>
                            ) : (
                              <option value='2'>---No {Class} to Select</option>
                            )}
                            {currentClasses?.map((item, index) => (
                              <option key={index} value={item.className}>
                                {item.className}
                              </option>
                            ))}
                          </select>
                        )}
                      </Field>
                      <ErrorMessage
                        name='className'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                    {/* section */}
                    {instituteType.toLowerCase() === 'college' && (
                      <div className='w-full '>
                        <label htmlFor='sectionName' className='text-sm'>
                          {Section} *
                        </label>
                        <Field name='sectionName'>
                          {({ field }) => (
                            <select
                              required={
                                instituteType.toLowerCase() === 'college'
                              }
                              {...field}
                              className='formik-input'
                              onChange={(e) => {
                                field.onChange(e);
                                const value = e.target.value;
                                setFieldValue('sectionName', value);
                              }}
                            >
                              {!values?.className ? (
                                <option value=''>
                                  ---First Select {Class}
                                  {''} ---
                                </option>
                              ) : currentClasses?.length > 0 ? (
                                <option value=''>
                                  ---Select {Section} ---
                                </option>
                              ) : (
                                <option value='2'>---No {Section} ---</option>
                              )}
                              {currentSections?.map((item, index) => (
                                <option key={index} value={item.section}>
                                  {item.section}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                        <ErrorMessage
                          name='sectionName'
                          component='div'
                          className='mt-1 text-sm text-red-600'
                        />
                      </div>
                    )}

                    <div className='w-full '>
                      <label htmlFor='totalFees' className='text-sm '>
                        Total Fee
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        type='text'
                        inputMode='numeric'
                        pattern='[0-9]*'
                        id='totalFees'
                        name='totalFees'
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            '',
                          );
                        }}
                        placeholder='₹0.00'
                        className='mt-0 formik-input'
                      />
                      {values?.totalFees > 0 && !errors?.totalFees && (
                        <small className='text-green-600 '>
                          {convertNumberToWords(values?.totalFees)}
                        </small>
                      )}
                      <ErrorMessage
                        name='totalFees'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>

                    <div className='w-full'>
                      <label htmlFor='dateOfJoining' className='text-sm '>
                        Date Of Joining
                        <span className='text-lg text-red-800 '>*</span>
                      </label>
                      <Field
                        name='dateOfJoining'
                        className='mt-1 formik-input'
                        component={ReactDatePicker}
                      />
                      <ErrorMessage
                        name='dateOfJoining'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>

                    <div className='w-full'>
                      <label htmlFor='dateOfLeaving' className='text-sm '>
                        Date Of Leaving
                        <span className='text-lg text-red-800 '> </span>
                      </label>
                      <Field
                        name='dateOfLeaving'
                        className='mt-1 formik-input'
                        component={ReactDatePicker}
                      />
                      <ErrorMessage
                        name='dateOfLeaving'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                  </div>
                  {/* Remarks ,Buttons  */}
                  <div className='grid items-baseline grid-cols-1 gap-3 mb-4 md:grid-cols-3'>
                    <div className='col-span-2'>
                      <label htmlFor='remarks' className='text-sm '>
                        Remarks
                      </label>
                      <Field
                        type='text'
                        id='remarks'
                        name='remarks'
                        placeholder='Enter remarks'
                        className='formik-input '
                      />
                      <ErrorMessage
                        name='remarks'
                        component='div'
                        className='mt-1 text-sm text-red-600'
                      />
                    </div>
                    <div className='flex items-end justify-center gap-3 mt-2 ml-auto '>
                      <Button
                        size='small'
                        variant='outlined'
                        type='reset'
                        className='px-4 py-2 normal-case'
                        onClick={() => setAddStudent(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        size='small'
                        variant='contained'
                        type='submit'
                        className='px-8 py-2 normal-case'
                      >
                        Save
                      </Button>
                    </div>{' '}
                  </div>
                </Form>
              </div>

              <Modal
                open={successModal}
                onClose={() => setSuccessModal(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <div className='fixed p-8 -translate-x-1/2 -translate-y-1/2 bg-white top-1/2 left-1/2 rounded-3xl'>
                  <img
                    src='/images/success.gif'
                    className='rounded-full size-[90] '
                  />
                  <h5 className='text-center'>
                    Student Registration Completed <br></br>
                  </h5>
                  <h5 className='text-center'> Successfully !</h5>
                </div>
              </Modal>
            </>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddStudent;
